import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultItemBgHover(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--itemBgHover', getDefaultPanelColors().itemBgHover);
}
